export default {
  label: "LiTrack",
};
